// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"LeftMenu_menuIcon__1K3k3","label":"LeftMenu_label__3wykd"};